import { render, staticRenderFns } from "./messageSuccess.vue?vue&type=template&id=c6507484&"
import script from "./messageSuccess.vue?vue&type=script&lang=js&"
export * from "./messageSuccess.vue?vue&type=script&lang=js&"
import style0 from "./messageSuccess.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports